<script setup lang="ts">
import { useScreen } from '@Shared/utils/useScreen';

defineProps<{
  hasNoData?: boolean;
}>();

const screenSize = useScreen();

const numberOfLines = computed<number>(() => {
  if (screenSize.value.width >= 3840) {
    return 5;
  } else if (screenSize.value.width >= 1920) {
    return 5;
  } else {
    return 4;
  }
});

const getLoadingGradientHeight = computed<string>(() => {
  let scale = 1;
  if (screenSize.value.width >= 3840) {
    scale = 4;
  } else if (screenSize.value.width >= 1920) {
    scale = 1.5;
  }

  return `${0.8 * scale}rem`;
});
</script>
<template>
  <div class="relative h-full flex flex-col bg-white rounded-[8px]">
    <div
      v-if="hasNoData"
      class="absolute top-45% left-0 text-center w-full text-[#828282] text-sm xl:text-3 2xl:text-4.5 3xl:text-9 3xl:line-height-3rem font-bold z-1000"
    >
      There are no new responses. <br />Please check again later.
    </div>
    <div class="flex flex-col flex-[1_1_auto] h-full">
      <div
        class="bg-[#CCD1D8] border-solid border-2 2xl:border-4 3xl:border-8 border-white rounded-t-2 pt-1 pl-2 pb-2 2xl:pt-4 2xl:pb-5 3xl:pt-9 3xl:pb-10 3xl:pl-6 flex-[0_1_auto] xl:text-4 2xl:text-5.5 3xl:text-11 text-lg"
      >
        <div class="inline-block loading-gradient h-100% w-33% rounded-2"></div>
      </div>
      <!-- drivers -->
      <div class="pl-3 pr-2 2xl:pl-6 2xl:pr-4 flex flex-col flex-grow">
        <div
          class="grid pt-1 pb-2 3xl:pt-4 3xl:pb-4 pl-2 2xl:pl-2 3xl:pl-4 pr-2 2xl:pr-2 3xl:pr-4 rounded xl:text-4 2xl:text-7 3xl:text-12 flex-grow"
          :style="{
            'grid-template-columns': `40% 1fr 1fr 0.5fr`,
            background: i % 2 == 0 ? '#F9F9F9' : undefined,
          }"
          v-for="i in numberOfLines"
          :key="i"
        >
          <!-- label -->
          <div class="loading-gradient self-center"></div>
          <!-- metric (not shown) -->
          <div class="text-center font-semibold self-center"></div>
          <!-- delta icon -->
          <div class="justify-self-end loading-gradient w-full mr-2 2xl:mr-4 3xl:mr-8 self-center"></div>
          <!-- delta value -->
          <div class="justify-self-start loading-gradient w-full self-center"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.loading-gradient {
  border-radius: 20px;
  height: v-bind('getLoadingGradientHeight');
}
</style>
